module.exports = __webpack_public_path__ + "img/message.acb3b62.png";